var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.job && _vm.currentNode
    ? _c(
        "div",
        _vm._l(_vm.currentNode.actions, function(action) {
          return _c(
            "el-button",
            {
              key: action.id,
              attrs: { no: "actionName", type: "primary" },
              on: {
                click: function() {
                  return _vm.handleClick(action)
                }
              }
            },
            [_vm._v(_vm._s(action.actionName))]
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }